import dedent from 'dedent-js';

import { getSupportLinks } from '../common/links';
import { OnboardingResponse } from '../types';

export default {
  getBotOnboardingText: (redirectUrl: string) => dedent`
    The Hints bot is connected.
    ${getSupportLinks('intercom')}
  `,
} as OnboardingResponse;
